export default {
  label: 'Gênero',
  placeholder: 'Todos',
};
